import script from "./_games-grid.vue?vue&type=script&setup=true&lang=ts"
export * from "./_games-grid.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__